import React from 'react';
import { getBranding } from '../scripts/branding';
import { getVisibleTools } from '../data/buddyTools';
import ThemeToggle from './ThemeToggle';
import BuddyToolList from './BuddyToolList';
import Footer from './Footer';
import './LandingPage.css';
import './BuddyToolList.css';

const LandingPage = ({ onLoginClick }) => {
  const branding = getBranding();
  const tools = getVisibleTools();

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header">
        {branding.logo?.type === 'text' ? (
          <span className="logo-text">{branding.toolName}</span>
        ) : (
          <div className="logo">
            <img src={branding.logo?.content} alt={`${branding.toolName} Logo`} className="logo-image" />
          </div>
        )}
        <nav className="landing-nav">
          <a href="#features" className="nav-link">Features</a>
          <a href="#use-cases" className="nav-link">Use Cases</a>
          <a href="#platform" className="nav-link">Platform</a>
          <a href="#pricing" className="nav-link">Pricing</a>
          <a href="https://citadelstrategicventures.com" target="_blank" rel="noopener noreferrer" className="nav-link">Resources</a>
          <a href={branding.companyLink} target="_blank" rel="noopener noreferrer" className="nav-link">
            About {branding.shortCompanyName}
          </a>
        </nav>
        <div className="header-controls">
          <ThemeToggle />
          <button onClick={onLoginClick} className="login-button">Login</button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-headline">Lorem Ipsum Dolor Sit Amet</h1>
          <p className="hero-subheadline">
            Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <button className="cta-button">Get Started</button>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <h2 className="section-title">Discover Our Tools</h2>
        <BuddyToolList
          tools={tools}
          isPublicPage={true}
        />
      </section>

      {/* Platform Section */}
      <section id="platform" className="features-section">
        <h2 className="section-title">Platform</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">Lorem Ipsum</h3>
              <p className="feature-description">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section id="use-cases" className="features-section">
        <h2 className="section-title">Use Cases</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">Lorem Ipsum</h3>
              <p className="feature-description">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="features-section">
        <h2 className="section-title">Pricing</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">Lorem Ipsum</h3>
              <p className="feature-description">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;